import axios from "axios";
import { Config } from "../config/config";

const GATEWAY_URL = `${Config.VITE_APP_GATEWAY_URL}/api/account/menu`;

export const menuservice = {
    getMenuByUser: async function () {
        return axios.get(`${GATEWAY_URL}/get-user-menu`)
            .then((response) => {
                return response.data;
            });
    },
    lookupMenu: async(params: any) =>{
        return axios.get(`${GATEWAY_URL}/lookup-menu`, {
            params
        }).then((response) => {
            return response.data;
        });
    },
}
export default menuservice